import { AnyAction } from '@reduxjs/toolkit';
import { SET_ACCOUNT_REPRESENTATIVE } from '../action-types';
import type { ISetAccountRepresentativeAction } from '../actions';
import type { TCustomerUserOrEmpty } from '../interfaces';

export const customerAccountRepresentativeReducer = (
  state: TCustomerUserOrEmpty = {},
  action: AnyAction,
): TCustomerUserOrEmpty => {
  switch (action.type) {
    case SET_ACCOUNT_REPRESENTATIVE: {
      return {
        ...(action as ISetAccountRepresentativeAction).payload,
      };
    }
    default:
      return state;
  }
};
